module.exports = __webpack_public_path__ + "static/img/picon.34d81c73.png";